import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

(function () {
  var SINGLE_DATA = [
    { height_ft: 6, bottles: 11 }, { height_ft: 6.5, bottles: 12 },
    { height_ft: 7, bottles: 13 }, { height_ft: 7.5, bottles: 14 },
    { height_ft: 8, bottles: 15 }, { height_ft: 8.5, bottles: 16 },
    { height_ft: 9, bottles: 17 }, { height_ft: 9.5, bottles: 18 },
    { height_ft: 10, bottles: 19 }, { height_ft: 10.5, bottles: 20 },
    { height_ft: 11, bottles: 21 }, { height_ft: 11.5, bottles: 22 },
    { height_ft: 12, bottles: 23 }, { height_ft: 12.5, bottles: 24 },
    { height_ft: 13, bottles: 25 }, { height_ft: 13.5, bottles: 26 },
    { height_ft: 14, bottles: 27 }
  ];

  var DOUBLE_DATA = [
    { height_ft: 6, bottles: 22 }, { height_ft: 6.5, bottles: 24 },
    { height_ft: 7, bottles: 26 }, { height_ft: 7.5, bottles: 28 },
    { height_ft: 8, bottles: 30 }, { height_ft: 8.5, bottles: 32 },
    { height_ft: 9, bottles: 34 }, { height_ft: 9.5, bottles: 36 },
    { height_ft: 10, bottles: 38 }, { height_ft: 10.5, bottles: 40 },
    { height_ft: 11, bottles: 42 }, { height_ft: 11.5, bottles: 44 },
    { height_ft: 12, bottles: 46 }, { height_ft: 12.5, bottles: 48 },
    { height_ft: 13, bottles: 50 }, { height_ft: 13.5, bottles: 52 },
    { height_ft: 14, bottles: 54 }
  ];

  var configState = { mode: 'single', index: 6 };
  var configImageRequest = 0;
  var finishImageRequest = 0;

  function bindOnce(element, key) {
    var attr = 'data-kvsche-' + key + '-bound';
    if (!element || element.getAttribute(attr) === 'true') return false;
    element.setAttribute(attr, 'true');
    return true;
  }

  function loadDeferredImage(image) {
    if (!image) return Promise.resolve(false);
    if (image.currentSrc || (image.complete && image.naturalWidth > 0)) return Promise.resolve(true);
    if (image.kvscheLoadPromise) return image.kvscheLoadPromise;

    image.kvscheLoadPromise = new Promise(function (resolve) {
      function finish(success) {
        if (!success || typeof image.decode !== 'function') {
          resolve(success);
          return;
        }
        image.decode().then(function () { resolve(true); }).catch(function () { resolve(true); });
      }

      image.addEventListener('load', function () { finish(true); }, { once: true });
      image.addEventListener('error', function () { finish(false); }, { once: true });
      if (image.dataset.sizes) image.sizes = image.dataset.sizes;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      if (image.complete) finish(image.naturalWidth > 0);
    });

    return image.kvscheLoadPromise;
  }

  function formatHeight(feet) {
    var whole = Math.floor(feet);
    var inch = Math.round((feet - whole) * 12);
    return inch ? whole + '′ ' + inch + '″' : whole + '′ 0″';
  }

  function scrollToSection(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: el.offsetTop - 80, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function updateConfigUI() {
    var data = configState.mode === 'single' ? SINGLE_DATA : DOUBLE_DATA;
    var row  = data[configState.index];
    var height   = formatHeight(row.height_ft);
    var isSingle = configState.mode === 'single';

    var tabSingle    = document.getElementById('config-tab-single');
    var tabDouble    = document.getElementById('config-tab-double');
    var imageSingle  = document.getElementById('config-image-single');
    var imageDouble  = document.getElementById('config-image-double');

    if (!tabSingle || !tabDouble) return;

    /* read editable content from section data attributes */
    var configSection    = document.getElementById('configurations');
    var copySingle       = configSection ? configSection.getAttribute('data-copy-single')        || '' : '';
    var copyDouble       = configSection ? configSection.getAttribute('data-copy-double')        || '' : '';
    var prefixSingle     = configSection ? configSection.getAttribute('data-title-prefix-single') || 'The Single Length,' : '';
    var prefixDouble     = configSection ? configSection.getAttribute('data-title-prefix-double') || 'The Double Length,' : '';
    var nameSingle       = configSection ? configSection.getAttribute('data-name-single')         || 'Single' : 'Single';
    var nameDouble       = configSection ? configSection.getAttribute('data-name-double')         || 'Double' : 'Double';
    var colLabelSingle   = configSection ? configSection.getAttribute('data-col-label-single')    || 'Column'  : 'Column';
    var colLabelDouble   = configSection ? configSection.getAttribute('data-col-label-double')    || 'Columns' : 'Columns';

    tabSingle.classList.toggle('kv-configs__tab--active', isSingle);
    tabDouble.classList.toggle('kv-configs__tab--active', !isSingle);
    tabSingle.setAttribute('aria-selected', isSingle ? 'true' : 'false');
    tabDouble.setAttribute('aria-selected', isSingle ? 'false' : 'true');

    var targetImage = isSingle ? imageSingle : imageDouble;
    var activeImageRequest = configImageRequest + 1;
    configImageRequest = activeImageRequest;
    loadDeferredImage(targetImage).then(function (loaded) {
      if (!loaded || activeImageRequest !== configImageRequest) return;
      if (imageSingle) imageSingle.classList.toggle('kv-configs__visual-img--hidden', !isSingle);
      if (imageDouble) imageDouble.classList.toggle('kv-configs__visual-img--hidden', isSingle);
    });

    var elName = document.getElementById('config-visual-name');
    if (elName) elName.textContent = isSingle ? nameSingle : nameDouble;

    var elTitle = document.getElementById('config-title');
    if (elTitle) elTitle.innerHTML =
      (isSingle ? prefixSingle : prefixDouble) + ' <em>at ' + height + '.</em>';

    var elCopy = document.getElementById('config-copy');
    if (elCopy) elCopy.textContent = isSingle ? copySingle : copyDouble;

    var elSpecHeight       = document.getElementById('config-spec-height');
    var elSpecBottles      = document.getElementById('config-spec-bottles');
    var elSpecColumnsLabel = document.getElementById('config-spec-columns-label');
    var elSpecColumns      = document.getElementById('config-spec-columns');
    var elHeightValue      = document.getElementById('config-height-value');
    var elBottleLine       = document.getElementById('config-bottle-line');

    if (elSpecHeight)       elSpecHeight.textContent       = height;
    if (elSpecBottles)      elSpecBottles.textContent      = String(row.bottles);
    if (elSpecColumnsLabel) elSpecColumnsLabel.textContent = isSingle ? colLabelSingle : colLabelDouble;
    if (elSpecColumns)      elSpecColumns.textContent      = isSingle ? '1' : '2';
    if (elHeightValue)      elHeightValue.textContent      = height;
    if (elBottleLine)       elBottleLine.textContent       = row.bottles + ' bottles';
  }

  function setFinish(index) {
    var buttons = document.querySelectorAll('[data-finish-index]');
    var target = document.getElementById('finish-hero-' + index);
    var activeImageRequest = finishImageRequest + 1;
    finishImageRequest = activeImageRequest;

    loadDeferredImage(target).then(function (loaded) {
      if (!loaded || activeImageRequest !== finishImageRequest) return;
      document.querySelectorAll('[id^="finish-hero-"]').forEach(function (hero, imageIndex) {
        hero.classList.toggle('kv-finishes__hero-img--hidden', imageIndex !== index);
      });
    });

    buttons.forEach(function (button, btnIndex) {
      var isActive = btnIndex === index;
      button.classList.toggle('kv-finishes__item--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    /* read finish display text from the active button's data attributes */
    var activeButton = document.querySelector('[data-finish-index="' + index + '"]');
    var elShort = document.getElementById('finish-short');
    var elTone  = document.getElementById('finish-tone');
    var elPairs = document.getElementById('finish-pairs');

    if (activeButton) {
      if (elShort) elShort.textContent = activeButton.getAttribute('data-finish-short') || '';
      if (elTone)  elTone.textContent  = activeButton.getAttribute('data-finish-tone')  || '';
      if (elPairs) elPairs.textContent = activeButton.getAttribute('data-finish-pairs') || '';
    }
  }

  function setupGlasswareCart() {
    function animateFlyToCart(btn) {
      var cartIcon = document.querySelector('.header-actions__cart-icon, .kv-nav__cart-icon');
      if (!cartIcon || !window.customElements || !customElements.get('fly-to-cart')) return;

      var imageSource = btn.closest('.kv-glassware__piece')?.querySelector('.kv-glassware__visual-img') || btn;
      var flyToCartElement = document.createElement('fly-to-cart');
      var image = '';

      if (imageSource && imageSource !== btn) {
        image = imageSource.currentSrc ? 'url("' + imageSource.currentSrc + '")' : window.getComputedStyle(imageSource).backgroundImage;
      }

      flyToCartElement.classList.add('fly-to-cart--main');
      if (image && image !== 'none') {
        flyToCartElement.style.setProperty('background-image', image);
      }
      flyToCartElement.source = imageSource;
      flyToCartElement.destination = cartIcon;
      document.body.appendChild(flyToCartElement);
    }

    document.querySelectorAll('[data-kv-atc]').forEach(function (btn) {
      if (!bindOnce(btn, 'atc')) return;

      btn.addEventListener('click', function (event) {
        event.preventDefault();

        var variantId = btn.getAttribute('data-variant-id');
        var qty       = parseInt(btn.getAttribute('data-quantity'), 10) || 1;

        if (!variantId) {
          console.warn('[KV] Add to cart: missing variant ID on button', btn);
          return;
        }

        /* collect section IDs so the drawer can re-render immediately */
        var sectionIds = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
          var id = el.getAttribute('data-section-id');
          if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
        });

        btn.disabled = true;
        animateFlyToCart(btn);

        var payload = { id: parseInt(variantId, 10), quantity: qty };
        if (sectionIds.length) payload.sections = sectionIds.join(',');

        var deferredCartUpdate = CartLinesUpdateEvent.createPromise();
        btn.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity: qty }],
            promise: deferredCartUpdate.promise,
            detail: { source: 'kv-glassware' }
          })
        );

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify(payload)
        })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (err) { throw err; });
            }
            return r.json();
          })
          .then(function (added) {
            if (added && added.status) {
              /* Shopify error — e.g. sold out, limit reached */
              console.warn('[KV] Add to cart failed:', added.description || added.message);
              var orig = btn.getAttribute('data-orig-text') || btn.textContent;
              btn.setAttribute('data-orig-text', orig);
              btn.textContent = added.message || 'Unavailable';
              btn.disabled = false;
              setTimeout(function () {
                btn.textContent = orig;
              }, 2800);
              throw added;
            }

            /* fetch full cart to get accurate item_count */
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) {
                if (!r.ok) return r.json().then(function (err) { throw err; });
                return r.json();
              })
              .then(function (cart) {
                deferredCartUpdate.resolve({
                  cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                  detail: {
                    itemCount: cart.item_count,
                    source:    'kv-glassware',
                    sections:  (added && added.sections) ? added.sections : {}
                  }
                });

                btn.disabled = false;
              });
          })
          .catch(function (err) {
            console.error('[KV] Add to cart error:', err);
            deferredCartUpdate.reject(err instanceof Error ? err : new Error((err && (err.description || err.message)) || 'Add to cart failed'));
            /* Dispatch cart error event for other components to handle */
            btn.dispatchEvent(
              new CartErrorEvent({
                error: (err && (err.description || err.message)) || 'Add to cart failed',
                code: 'INVALID',
                detail: { source: 'kv-glassware', errors: err && err.errors }
              })
            );
            btn.disabled = false;
          });
      });
    });
  }

  function setupReveals() {
    var revealEls = document.querySelectorAll('.kv-reveal');
    function reveal(element) {
      var deferredImage = element.querySelector('[data-kvsche-reveal-image]');
      if (deferredImage) loadDeferredImage(deferredImage);
      element.classList.add('kv-reveal--in');
    }
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(reveal);
      return;
    }
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    revealEls.forEach(function (el) { observer.observe(el); });
  }

  function setupEditorialHero() {
    document.querySelectorAll('[data-kv-hero-slideshow]').forEach(function (hero) {
      if (!bindOnce(hero, 'editorial-hero')) return;

      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-kv-hero-slide]'));
      var panels = Array.prototype.slice.call(hero.querySelectorAll('[data-kv-hero-panel]'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-kv-hero-dot]'));
      var micro = hero.querySelector('[data-kv-hero-micro]');
      var prev = hero.querySelector('[data-kv-hero-prev]');
      var next = hero.querySelector('[data-kv-hero-next]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var delay = parseInt(hero.getAttribute('data-autoplay'), 10) || 8000;
      var index = 0;
      var timer = null;
      var paused = false;
      var hasInteracted = false;
      var requestId = 0;
      var touchStartX = 0;
      var touchStartY = 0;
      var slideLoads = [];

      if (!slides.length || !panels.length) return;

      function readMicro(i) {
        var panel = panels[i];
        if (!panel) return '';
        return panel.getAttribute('data-micro-line') || '';
      }

      function setActive(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('kv-hero__slide--active', i === index);
        });
        panels.forEach(function (panel, i) {
          var active = i === index;
          panel.classList.toggle('kv-hero__panel--active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('kv-hero__dot--active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (micro) {
          var text = readMicro(index);
          if (!text) {
            var fallback = ['No cellar required.', 'Measured to your height.', 'Finished to suit the room.', 'Built into the atmosphere.'];
            text = fallback[index] || fallback[0];
          }
          micro.textContent = text;
        }
      }

      function loadSlide(nextIndex) {
        var normalizedIndex = (nextIndex + slides.length) % slides.length;
        var slide = slides[normalizedIndex];
        var image = slide ? slide.querySelector('img') : null;
        var sources = slide ? Array.prototype.slice.call(slide.querySelectorAll('source')) : [];

        if (!image) return Promise.resolve(false);
        if (image.currentSrc || (image.complete && image.naturalWidth > 0)) return Promise.resolve(true);
        if (slideLoads[normalizedIndex]) return slideLoads[normalizedIndex];

        slideLoads[normalizedIndex] = new Promise(function (resolve) {
          function finish(success) {
            if (!success || typeof image.decode !== 'function') {
              resolve(success);
              return;
            }
            image.decode().then(function () { resolve(true); }).catch(function () { resolve(true); });
          }

          image.addEventListener('load', function () { finish(true); }, { once: true });
          image.addEventListener('error', function () { finish(false); }, { once: true });

          sources.forEach(function (source) {
            if (source.dataset.sizes) source.sizes = source.dataset.sizes;
            if (source.dataset.srcset) source.srcset = source.dataset.srcset;
          });
          if (image.dataset.sizes) image.sizes = image.dataset.sizes;
          if (image.dataset.srcset) image.srcset = image.dataset.srcset;
          if (image.dataset.src) image.src = image.dataset.src;

          if (image.complete) finish(image.naturalWidth > 0);
        });

        return slideLoads[normalizedIndex];
      }

      function stop() {
        if (timer) window.clearTimeout(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!hasInteracted || reduceMotion || slides.length < 2 || paused) return;
        timer = window.setTimeout(function () {
          requestSlide(index + 1, false);
        }, delay);
      }

      function requestSlide(nextIndex, deliberate) {
        var normalizedIndex = (nextIndex + slides.length) % slides.length;
        var activeRequest = requestId + 1;
        requestId = activeRequest;
        if (deliberate) {
          hasInteracted = true;
          hero.classList.add('kv-hero--interacted');
        }

        if (normalizedIndex === index) {
          start();
          return;
        }

        stop();
        loadSlide(normalizedIndex).then(function (loaded) {
          if (!loaded || activeRequest !== requestId) {
            if (!loaded) console.warn('[KV] Hero image failed to load for slide', normalizedIndex + 1);
            return;
          }
          setActive(normalizedIndex);
          start();
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          requestSlide(parseInt(dot.getAttribute('data-slide-index'), 10) || 0, true);
        });
      });
      if (prev) prev.addEventListener('click', function () { requestSlide(index - 1, true); });
      if (next) next.addEventListener('click', function () { requestSlide(index + 1, true); });

      hero.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        requestSlide(index + (event.key === 'ArrowLeft' ? -1 : 1), true);
      });

      hero.addEventListener('touchstart', function (event) {
        if (!event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      hero.addEventListener('touchend', function (event) {
        if (!event.changedTouches.length) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        requestSlide(index + (deltaX < 0 ? 1 : -1), true);
      }, { passive: true });

      hero.addEventListener('mouseenter', function () {
        paused = true;
        stop();
      });
      hero.addEventListener('mouseleave', function () {
        paused = false;
        start();
      });
      setActive(0);
    });
  }

  function setupEvents() {
    /* smooth-scroll anchors */
    document.querySelectorAll('[data-scroll-to]').forEach(function (link) {
      if (!bindOnce(link, 'scroll-to')) return;

      link.addEventListener('click', function (event) {
        event.preventDefault();
        var id = link.getAttribute('data-scroll-to');
        if (id) scrollToSection(id);
      });
    });

    /* logo → scroll to top */
    var topLink = document.querySelector('[data-scroll-top]');
    if (bindOnce(topLink, 'scroll-top')) {
      topLink.addEventListener('click', function (event) {
        event.preventDefault();
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    /* nav dropdown links that jump to a config mode */
    document.querySelectorAll('[data-config-jump]').forEach(function (link) {
      if (!bindOnce(link, 'config-jump')) return;

      link.addEventListener('click', function (event) {
        event.preventDefault();
        configState.mode = link.getAttribute('data-config-jump') === 'double' ? 'double' : 'single';
        updateConfigUI();
        scrollToSection('configurations');
      });
    });

    /* config tabs */
    var tabSingle = document.getElementById('config-tab-single');
    var tabDouble = document.getElementById('config-tab-double');
    var slider    = document.getElementById('config-height-slider');

    if (bindOnce(tabSingle, 'config-tab')) tabSingle.addEventListener('click', function () {
      configState.mode = 'single';
      updateConfigUI();
    });
    if (bindOnce(tabDouble, 'config-tab')) tabDouble.addEventListener('click', function () {
      configState.mode = 'double';
      updateConfigUI();
    });
    if (bindOnce(slider, 'config-slider')) slider.addEventListener('input', function () {
      configState.index = parseInt(slider.value, 10);
      updateConfigUI();
    });

    /* finish selector */
    document.querySelectorAll('[data-finish-index]').forEach(function (button) {
      if (!bindOnce(button, 'finish')) return;

      function handleActivate() {
        setFinish(parseInt(button.getAttribute('data-finish-index'), 10));
      }
      button.addEventListener('click',      handleActivate);
      button.addEventListener('mouseenter', handleActivate);
    });

    /* newsletter — prevent default submit until Shopify form is wired */
    var newsletterForm = document.getElementById('newsletter-form');
    if (bindOnce(newsletterForm, 'newsletter')) {
      newsletterForm.addEventListener('submit', function (event) {
        event.preventDefault();
      });
    }

    /* lifestyle day / night toggle */
    var lifestyleWrap = document.getElementById('lifestyle-wide-quote');
    if (lifestyleWrap) {
      var modeButtons = lifestyleWrap.querySelectorAll('[data-lifestyle-mode]');
      var lifestyleImageRequest = 0;

      function setLifestyleMode(mode) {
        var target = lifestyleWrap.querySelector('.kv-lifestyle__wide-image--' + mode);
        var activeImageRequest = lifestyleImageRequest + 1;
        lifestyleImageRequest = activeImageRequest;
        loadDeferredImage(target).then(function (loaded) {
          if (!loaded || activeImageRequest !== lifestyleImageRequest) return;
          lifestyleWrap.classList.remove('kv-lifestyle__wide--day', 'kv-lifestyle__wide--night');
          lifestyleWrap.classList.add(mode === 'day' ? 'kv-lifestyle__wide--day' : 'kv-lifestyle__wide--night');
          modeButtons.forEach(function (btn) {
            btn.classList.toggle(
              'kv-lifestyle__mode-btn--active',
              btn.getAttribute('data-lifestyle-mode') === mode
            );
          });
        });
      }

      modeButtons.forEach(function (btn) {
        if (!bindOnce(btn, 'lifestyle-mode')) return;

        btn.addEventListener('mouseenter', function () { setLifestyleMode(btn.getAttribute('data-lifestyle-mode')); });
        btn.addEventListener('focus',      function () { setLifestyleMode(btn.getAttribute('data-lifestyle-mode')); });
      });
      if (bindOnce(lifestyleWrap, 'lifestyle-wrap')) {
        lifestyleWrap.addEventListener('mouseleave', function () { setLifestyleMode('night'); });
      }
    }

    /* Prevent anchor '#' jumps in glassware fallback links — navigate to product page if available */
    document.querySelectorAll('.kv-glassware__actions a.kv-link').forEach(function (link) {
      if (!bindOnce(link, 'glassware-link')) return;

      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href === '#') {
          var productUrl = link.getAttribute('data-product-url');
          if (productUrl) {
            event.preventDefault();
            window.location.href = productUrl;
          } else {
            // Prevent jump to top when href is '#'
            event.preventDefault();
            console.warn('[KV] Glassware link had no product URL and href="#" — no action taken');
          }
        }
      });
    });
  }

  function initKvscheHomepage() {
    setupEditorialHero();
    setupReveals();
    setupEvents();
    setupGlasswareCart();
    updateConfigUI();
    setFinish(0);
  }

  function isKvscheHomepageSection(root) {
    if (!root || !root.querySelector) return false;

    var selectors = [
      '[data-kv-hero-slideshow]',
      '.kv-reveal',
      '[data-scroll-to]',
      '[data-scroll-top]',
      '[data-config-jump]',
      '#configurations',
      '[data-finish-index]',
      '#newsletter-form',
      '#lifestyle-wide-quote',
      '[data-kv-atc]',
      '.kv-glassware__actions a.kv-link'
    ].join(',');

    return Boolean(
      (root.matches && root.matches(selectors)) ||
      root.querySelector(selectors)
    );
  }

  initKvscheHomepage();

  document.addEventListener('shopify:section:load', function (event) {
    if (!isKvscheHomepageSection(event.target)) return;
    initKvscheHomepage();
  });
})();
